import { Component, inject } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { Loading } from '@sharedComponents/loading/loading';
import { ThemeService } from '@sharedServices/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatSlideToggleModule, TranslateModule, Loading],
  providers: [ThemeService],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private _themeService = inject(ThemeService);

  constructor(private _translte: TranslateService) {
    const lang = localStorage.getItem('lang') ? localStorage.getItem('lang')! : 'es';
    _translte.setDefaultLang('es');
    _translte.use(lang);
    this._themeService.setTheme();
  }
}
